export const genders = [
  {
    name: "male",
  },
  {
    name: "female",
  },
  {
    name: "prefer not to say",
  },
];

export const nationalities = [
  { name: "Afghan" },
  { name: "Albanian" },
  { name: "Algerian" },
  { name: "American" },
  { name: "Andorran" },
  { name: "Angolan" },
  { name: "Antiguans" },
  { name: "Argentinean" },
  { name: "Armenian" },
  { name: "Australian" },
  { name: "Austrian" },
  { name: "Azerbaijani" },
  { name: "Bahamian" },
  { name: "Bahraini" },
  { name: "Bangladeshi" },
  { name: "Barbadian" },
  { name: "Barbudans" },
  { name: "Batswana" },
  { name: "Belarusian" },
  { name: "Belgian" },
  { name: "Belizean" },
  { name: "Beninese" },
  { name: "Bhutanese" },
  { name: "Bolivian" },
  { name: "Bosnian" },
  { name: "Brazilian" },
  { name: "British" },
  { name: "Bruneian" },
  { name: "Bulgarian" },
  { name: "Burkinabe" },
  { name: "Burmese" },
  { name: "Burundian" },
  { name: "Cambodian" },
  { name: "Cameroonian" },
  { name: "Canadian" },
  { name: "Cape Verdean" },
  { name: "Central African" },
  { name: "Chadian" },
  { name: "Chilean" },
  { name: "Chinese" },
  { name: "Colombian" },
  { name: "Comoran" },
  { name: "Congolese" },
  { name: "Costa Rican" },
  { name: "Croatian" },
  { name: "Cuban" },
  { name: "Cypriot" },
  { name: "Czech" },
  { name: "Danish" },
  { name: "Djibouti" },
  { name: "Dominican" },
  { name: "Dutch" },
  { name: "East Timorese" },
  { name: "Ecuadorean" },
  { name: "Egyptian" },
  { name: "Emirian" },
  { name: "Equatorial Guinean" },
  { name: "Eritrean" },
  { name: "Estonian" },
  { name: "Ethiopian" },
  { name: "Fijian" },
  { name: "Filipino" },
  { name: "Finnish" },
  { name: "French" },
  { name: "Gabonese" },
  { name: "Gambian" },
  { name: "Georgian" },
  { name: "German" },
  { name: "Ghanaian" },
  { name: "Greek" },
  { name: "Grenadian" },
  { name: "Guatemalan" },
  { name: "Guinea-Bissauan" },
  { name: "Guinean" },
  { name: "Guyanese" },
  { name: "Haitian" },
  { name: "Herzegovinian" },
  { name: "Honduran" },
  { name: "Hungarian" },
  { name: "I-Kiribati" },
  { name: "Icelander" },
  { name: "Indian" },
  { name: "Indonesian" },
  { name: "Iranian" },
  { name: "Iraqi" },
  { name: "Irish" },
  { name: "Israeli" },
  { name: "Italian" },
  { name: "Ivorian" },
  { name: "Jamaican" },
  { name: "Japanese" },
  { name: "Jordanian" },
  { name: "Kazakhstani" },
  { name: "Kenyan" },
  { name: "Kittian and Nevisian" },
  { name: "Kuwaiti" },
  { name: "Kyrgyz" },
  { name: "Laotian" },
  { name: "Latvian" },
  { name: "Lebanese" },
  { name: "Liberian" },
  { name: "Libyan" },
  { name: "Liechtensteiner" },
  { name: "Lithuanian" },
  { name: "Luxembourger" },
  { name: "Macedonian" },
  { name: "Malagasy" },
  { name: "Malawian" },
  { name: "Malaysian" },
  { name: "Maldivan" },
  { name: "Malian" },
  { name: "Maltese" },
  { name: "Marshallese" },
  { name: "Mauritanian" },
  { name: "Mauritian" },
  { name: "Mexican" },
  { name: "Micronesian" },
  { name: "Moldovan" },
  { name: "Monacan" },
  { name: "Mongolian" },
  { name: "Moroccan" },
  { name: "Mosotho" },
  { name: "Motswana" },
  { name: "Mozambican" },
  { name: "Namibian" },
  { name: "Nauruan" },
  { name: "Nepalese" },
  { name: "New Zealander" },
  { name: "Nicaraguan" },
  { name: "Nigerian" },
  { name: "Nigerien" },
  { name: "North Korean" },
  { name: "Northern Irish" },
  { name: "Norwegian" },
  { name: "Omani" },
  { name: "Pakistani" },
  { name: "Palauan" },
  { name: "Panamanian" },
  { name: "Papua New Guinean" },
  { name: "Paraguayan" },
  { name: "Peruvian" },
  { name: "Polish" },
  { name: "Portuguese" },
  { name: "Qatari" },
  { name: "Romanian" },
  { name: "Russian" },
  { name: "Rwandan" },
  { name: "Saint Lucian" },
  { name: "Salvadoran" },
  { name: "Samoan" },
  { name: "San Marinese" },
  { name: "Sao Tomean" },
  { name: "Saudi" },
  { name: "Scottish" },
  { name: "Senegalese" },
  { name: "Serbian" },
  { name: "Seychellois" },
  { name: "Sierra Leonean" },
  { name: "Singaporean" },
  { name: "Slovakian" },
  { name: "Slovenian" },
  { name: "Solomon Islander" },
  { name: "Somali" },
  { name: "South African" },
  { name: "South Korean" },
  { name: "Spanish" },
  { name: "Sri Lankan" },
  { name: "Sudanese" },
  { name: "Surinamer" },
  { name: "Swazi" },
  { name: "Swedish" },
  { name: "Swiss" },
  { name: "Syrian" },
  { name: "Taiwanese" },
  { name: "Tajik" },
  { name: "Tanzanian" },
  { name: "Thai" },
  { name: "Togolese" },
  { name: "Tongan" },
  { name: "Trinidadian or Tobagonian" },
  { name: "Tunisian" },
  { name: "Turkish" },
  { name: "Tuvaluan" },
  { name: "Ugandan" },
  { name: "Ukrainian" },
  { name: "Uruguayan" },
  { name: "Uzbekistani" },
  { name: "Venezuelan" },
  { name: "Vietnamese" },
  { name: "Welsh" },
  { name: "Yemenite" },
  { name: "Zambian" },
  { name: "Zimbabwean" },
  { name: "others" },
];

export const occupations = [
  { name: "Accountant" },
  { name: "Actor" },
  { name: "Actuary" },
  { name: "Advertising executive" },
  { name: "Agricultural engineer" },
  { name: "Air traffic controller" },
  { name: "Aircraft pilot" },
  { name: "Ambassador" },
  { name: "Architect" },
  { name: "Artist" },
  { name: "Astronaut" },
  { name: "Astronomer" },
  { name: "Athlete" },
  { name: "Author" },
  { name: "Baker" },
  { name: "Banker" },
  { name: "Barber" },
  { name: "Bartender" },
  { name: "Biologist" },
  { name: "Botanist" },
  { name: "Builder" },
  { name: "Bus driver" },
  { name: "Carpenter" },
  { name: "Chef" },
  { name: "Chemist" },
  { name: "Civil engineer" },
  { name: "Cleaner" },
  { name: "Coach" },
  { name: "Computer programmer" },
  { name: "Construction worker" },
  { name: "Dancer" },
  { name: "Dentist" },
  { name: "Detective" },
  { name: "Dietitian" },
  { name: "Doctor" },
  { name: "Economist" },
  { name: "Electrician" },
  { name: "Engineer" },
  { name: "Entertainer" },
  { name: "Farmer" },
  { name: "Fashion designer" },
  { name: "Firefighter" },
  { name: "Fisherman" },
  { name: "Flight attendant" },
  { name: "Florist" },
  { name: "Footballer" },
  { name: "Forester" },
  { name: "Gardener" },
  { name: "Geologist" },
  { name: "Hairdresser" },
  { name: "Historian" },
  { name: "Interpreter" },
  { name: "Journalist" },
  { name: "Judge" },
  { name: "Lawyer" },
  { name: "Lecturer" },
  { name: "Librarian" },
  { name: "Lifeguard" },
  { name: "Linguist" },
  { name: "Locksmith" },
  { name: "Machinist" },
  { name: "Magician" },
  { name: "Manager" },
  { name: "Marine biologist" },
  { name: "Mathematician" },
  { name: "Mechanic" },
  { name: "Meteorologist" },
  { name: "Midwife" },
  { name: "Miner" },
  { name: "Model" },
  { name: "Musician" },
  { name: "Nurse" },
  { name: "Optician" },
  { name: "Painter" },
  { name: "Paleontologist" },
  { name: "Paramedic" },
  { name: "Pastor" },
  { name: "Pharmacist" },
  { name: "Photographer" },
  { name: "Physician" },
  { name: "Physicist" },
  { name: "Pilot" },
  { name: "Plumber" },
  { name: "Police officer" },
  { name: "Politician" },
  { name: "Professor" },
  { name: "Psychiatrist" },
  { name: "Psychologist" },
  { name: "Public speaker" },
  { name: "Publisher" },
  { name: "Radiologist" },
  { name: "Receptionist" },
  { name: "Referee" },
  { name: "Reporter" },
  { name: "Researcher" },
  { name: "Salesperson" },
  { name: "Scientist" },
  { name: "Secretary" },
  { name: "Singer" },
  { name: "Social worker" },
  { name: "Soldier" },
  { name: "Solicitor" },
  { name: "Songwriter" },
  { name: "Speech therapist" },
  { name: "Statistician" },
  { name: "Stunt performer" },
  { name: "Surgeon" },
  { name: "Surveyor" },
  { name: "Taxi driver" },
  { name: "Teacher" },
  { name: "Technician" },
  { name: "Therapist" },
  { name: "Translator" },
  { name: "Tutor" },
  { name: "Veterinarian" },
  { name: "Waiter/waitress" },
  { name: "Web developer" },
  { name: "Welder" },
  { name: "Writer" },
  { name: "Zookeeper" },
  { name: "others" },
];

export const indieQuestionaires = [
  {
    question: "Are you into Politics",
  },
  {
    question: "Are you related to a PEP",
  },
];

export const indieInitialState = {
  personalInfo: [
    {
      IDName: "",
      meansID: "",
      gender: "",
      issueDate: "",
      expiryDate: "",
      IDNo: "",
      resPermitNo: "",
      stateOfOrigin: "",
      resAddress: "",
      workAddress: "",
      phoneNos: "",
      email: "",
      taxID: "",
      DOB: "",
      nationality: "",
      occupation: "",
      posHeld: "",
      employerName: "",
      indieSignatoryName: "",
      indieSignatoryDate: "",
    },
  ],
  socials: [],
  questionnaires: [],

  documents: [
    {
      validIDDoc: null,
      proofOfAddressDoc: null,
    },
  ],
};
